module.exports = __webpack_public_path__ + "static/media/s_v10_13.6f35c86a.mp3";